import React from 'react';

export type MobileFilterBarDateRange = { from: Date; to: Date };

export type MobileFilterBarProps = {
  dateRange?: MobileFilterBarDateRange;
  onDateClick?: () => void;
  onMenuClick?: () => void;
};

/** Same formatting as desktop `DateRangePicker.formatDateRange`. */
function formatDateRange(dateRange: MobileFilterBarProps['dateRange']): string {
  if (!dateRange?.from || !dateRange?.to) {
    return '';
  }

  const formatDate = (date: Date) => {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  return `${formatDate(dateRange.from)} - ${formatDate(dateRange.to)}`;
}

const MobileFilterBar: React.FC<MobileFilterBarProps> = ({
  dateRange,
  onDateClick,
  onMenuClick,
}) => {
  return (
    <div className="mobile-filter-bar">
      <button
        type="button"
        className="mobile-filter-date"
        onClick={onDateClick}
      >
        <span aria-hidden>📅</span>
        <span className="mobile-filter-date-text">{formatDateRange(dateRange)}</span>
      </button>

      <button
        type="button"
        className="mobile-filter-menu"
        onClick={onMenuClick}
      >
        ⋯
      </button>
    </div>
  );
};

export default MobileFilterBar;
